import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Step from "@fae/source/models/Step.js"
import Objdict from "objdict"

import ProgressReportsHUD from "@fae/source/data/games/school/views/ProgressReportsHUD.jsx"

import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import GenerateStudents from "@fae/source/data/games/school/scripts/GenerateStudents.js"

export default {
    "key": "prince",
    "stage": {
        "images": [
            {
                "url": require("../../dotgridbg.png"),
                "position": {"x": 0, "y": 0, "z": -1},
                "screenspace": "camera",
                "width": 16, "height": 9,
            },
            // {
            //     "url": require("./room.png"),
            //     "position": {"x": 0, "y": 0, "z": 2},
            //     "width": 16, "height": 9,
            //     "isSquiggling": true,
            // },
            {
                "type": "lined-polygon",
                "position": {"x": 0, "y": 0, "z": 2},
                "points": require("./encounters.json")[0].points,
                "color": "#000",
                "isSquiggling": true,
            }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "width": 16,
            "height": 9,
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "hud": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }

            return (
                <ProgressReportsHUD stage={stage}/>
            )
            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    Step.flag("hud", "hidden"),
                    Step.flag("ShowAllTheGuys", true),
                    Step.flag("ShowAllTheGuysWithoutTransparency", true),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({"spotTag": "goodspawn", "ignoreUnitKey": "teacher"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    GenerateStudents({
                        "unitCount": 4, // 5
                        "level": 5, // Math.min(5, Math.max(1, Math.ceil((App?.game?.overworld?.currentTime ?? 1) / 2) + 1)),
                        "jobKeys": ["school/sword", "school/spear", "school/axe", "school/axe", "school/dagger", "school/bow", "school/shaman"], // "dagger"
                        "title": "Upperclassmen",
                        "images": {
                            "school/sword": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKRED.png"),
                            "school/dagger": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPRED.png"),
                            "school/axe": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
                            "school/spear": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKBLUE.png"),
                            "school/bow": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKBLUE.png"),
                            "school/shaman": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
                        }
                    }),
                    Step.flag("modal", null),
                    Step.flag("hud", null),
                ]
            },
            // {
            //     "type": "condition",
            //     "isWinCondition": true,
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == 1
            //             && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
            //                 "affiliation": stage.player.affiliation
            //             })
            //     },
            //     "events": [
            //         PlotSteps.ChapterSuccess(),
            //         {"func": () => Navigation.go("/games/school")},
            //         // PlotSteps.HealPlayerParty({"percent": 0}),
            //         // PlotSteps.MovePlayerPartyToNewEncounter({
            //         //     "nextEncounterKey": 2,
            //         //     "spotTag": "goodspawn"
            //         // })
            //     ]
            // },
            // {
            //     "type": "condition",
            //     "isWinCondition": true,
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == 2
            //             && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
            //                 "affiliation": stage.player.affiliation
            //             })
            //     },
            //     "events": [
            //         PlotSteps.HealPlayerParty({"percent": 0}),
            //         PlotSteps.MovePlayerPartyToNewEncounter({
            //             "nextEncounterKey": 3,
            //             "spotTag": "goodspawn"
            //         })
            //     ]
            // },
            // {
            //     "type": "condition",
            //     "isWinCondition": true,
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == 3
            //             && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
            //                 "affiliation": stage.player.affiliation
            //             })
            //     },
            //     "events": [
            //         PlotSteps.HealPlayerParty({"percent": 0}),
            //         PlotSteps.MovePlayerPartyToNewEncounter({
            //             "nextEncounterKey": 4,
            //             "spotTag": "goodspawn"
            //         })
            //     ]
            // },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    // PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/school/credits")},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return App.game.player.overworld.currentTime >= App.game.overworld.endTime
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation,
                            "doNotIncludeUnitKey": "teacher"
                        })
                },
                "events": [
                    PlotSteps.ChapterFailure({"message": "Flunked"}),
                    // WE DO NOT SAVE XP EARNED ...??
                    PlotSteps.TransitionStart({"isUnskippable": true}),
                    {"func": () => Navigation.go("/games/school/overworld")},
                    PlotSteps.TransitionEnd({"isUnskippable": true}),
                    {"func": () => App.game.player.overworld.currentTime += 1},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return App.game.player.overworld.currentTime < App.game.overworld.endTime
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation,
                            "doNotIncludeUnitKey": "teacher"
                        })
                },
                "events": [
                    PlotSteps.ChapterSuccess({"message": "Class Dismissed"}),
                    PlotSteps.TransitionStart({"isUnskippable": true}),
                    {"func": () => Navigation.go("/games/school/overworld")},
                    PlotSteps.TransitionEnd({"isUnskippable": true}),
                    PlotSteps.Wait(500),
                    {"func": () => App.game.player.overworld.currentTime += 1},
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    HandleSlowDeath(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
        ]
    },
}
